const PermissionsService = {
    hasPermission: (requiredRoles: string[], roles: string[] = []): boolean => {
        if (!requiredRoles || requiredRoles.length === 0) return true;
        if (!roles) return false;

        // Only Super User / Super Admin role auto-bypass
        const isSuperUser = roles.some(role => 
            ['superuser', 'superadmin'].includes((role || '').toLowerCase())
        );
        if (isSuperUser) {
            return true;
        }

        const requiredLower = requiredRoles.map(rr => rr.toLowerCase());
        return roles.some(role => requiredLower.includes((role || '').toLowerCase()));
    }
}

export default PermissionsService;